
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedChefs from './components/FeaturedChefs';
import RecommendedChefs from './components/RecommendedChefs';
import ServicesSection from './components/ServicesSection';
import HowItWorks from './components/HowItWorks';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    // Update page title and meta description
    document.title = 'SERVDFRESH - Premium Private Chef Services South Africa | Johannesburg Cape Town Durban';
    
    // Add Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "SERVDFRESH",
      "description": "Premium private chef services connecting clients with South Africa's finest culinary professionals",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
      "logo": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/logo.png`,
      "image": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/og-image.jpg`,
      "telephone": "+27-11-123-4567",
      "email": "hello@servdfresh.co.za",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "123 Culinary Street",
        "addressLocality": "Sandton",
        "addressRegion": "Gauteng",
        "postalCode": "2196",
        "addressCountry": "ZA"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": -26.2041,
        "longitude": 28.0473
      },
      "openingHours": [
        "Mo-Fr 08:00-18:00",
        "Sa 09:00-14:00"
      ],
      "serviceArea": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": -26.2041,
          "longitude": 28.0473
        },
        "geoRadius": "500000"
      },
      "priceRange": "R500-R5000",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "247"
      },
      "sameAs": [
        "https://www.facebook.com/servdfresh",
        "https://www.instagram.com/servdfresh",
        "https://www.linkedin.com/company/servdfresh"
      ]
    });
    document.head.appendChild(schemaScript);

    return () => {
      // Cleanup
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <h1 className="sr-only">SERVDFRESH - Premium Private Chef Services</h1>
        <HeroSection />
        <FeaturedChefs />
        <RecommendedChefs />
        <ServicesSection />
        <HowItWorks />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
